import React from 'react';
export function AnnouncementBar() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="sticky top-0 z-50 bg-brand-charcoal text-white py-3 px-4 text-center" data-id="element-16">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-sm md:text-base" data-id="element-17">
        <span className="font-medium" data-id="element-18">
          ⏰ PRECIO DE LANZAMIENTO:{' '}
          <span className="font-bold text-brand-orange" data-id="element-19">$9.99</span> — Sube a
          $15.99 muy pronto
        </span>
        <button onClick={scrollToPricing} className="text-brand-orange hover:text-white font-bold transition-colors flex items-center gap-1" data-id="element-20">
          👉 DESCARGAR AHORA
        </button>
      </div>
    </div>;
}